import CategoryManagementModel from '../CategoryManagementModel'

export const dataMixin = {
  data() {
    return {
      dataBreadCrumd: CategoryManagementModel.dataBreadCrumd,
    }
  }
}
